// extracted by mini-css-extract-plugin
export default {"stand":"Stand_stand__KONlT","inputs":"Stand_inputs__BCjzx","buttons":"Stand_buttons__gyz7O","checkboxes":"Stand_checkboxes__y915N"};